"use client";

import { Leaf, Mountain, Recycle, Shield } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function () {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: badgesRef,
    isVisible: badgesVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const brands = ["Vanguard", "Shield", "Integrity", "Security", "Assurance", "Protection", "Reliability", "Stability", "Coverage", "Certainty"];
  const certifications = [{
    icon: Shield,
    label: "24/7 Claims Support",
    description: "Dedicated assistance whenever you need it most"
  }, {
    icon: Leaf,
    label: "Financial Stability",
    description: "Backed by industry-leading capital reserves"
  }, {
    icon: Recycle,
    label: "Secure Processing",
    description: "Bank-grade encryption for all policy data"
  }, {
    icon: Mountain,
    label: "Proven Reliability",
    description: "Decades of protecting your most valuable assets"
  }];
  return <section data-section-id="362" id="certified-security-trust" className="bg-background text-foreground py-20 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div ref={headerRef} className={`text-center mx-auto max-w-2xl mb-14 transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-mono text-xs tracking-[0.25em] uppercase text-chart-1 mb-4">
            Our Commitment
          </p>
          <h2 className="font-serif font-default text-3xl lg:text-4xl text-foreground mb-4 tracking-tight">
            Certified Security & Trust
          </h2>
          <p className="font-default text-base text-muted-foreground max-w-xl mx-auto leading-relaxed">
            Vanguard Shield Insurance provides the foundation of certainty you need to protect your future with confidence and professional integrity.
          </p>
        </div>

        {}
        <div className="relative mb-16">
          <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-background to-transparent z-10 pointer-events-none" />
          <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-background to-transparent z-10 pointer-events-none" />

          <div className="flex overflow-hidden">
            <div className="flex shrink-0 animate-marquee gap-16 items-center pr-16">
              {brands.map((brand, i) => <div key={`a-${i}`} data-index={i} className="h-12 flex items-center justify-center shrink-0">
                  <span className="font-serif text-2xl text-foreground/70 hover:text-foreground transition-colors whitespace-nowrap tracking-wide">
                    {brand}
                  </span>
                </div>)}
            </div>
            <div className="flex shrink-0 animate-marquee gap-16 items-center pr-16" aria-hidden="true">
              {brands.map((brand, i) => <div key={`b-${i}`} data-index={i} className="h-12 flex items-center justify-center shrink-0">
                  <span className="font-serif text-2xl text-foreground/70 whitespace-nowrap tracking-wide">
                    {brand}
                  </span>
                </div>)}
            </div>
          </div>
        </div>

        {}
        <div ref={badgesRef} className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 transition-all duration-700 ease-out ${badgesVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          {certifications.map((cert, i) => {
          const Icon = cert.icon;
          return <div key={i} data-index={i} className="relative flex flex-col items-center text-center px-6 py-4 group">
                {i < certifications.length - 1 && <div className="hidden lg:flex absolute right-0 top-1/2 -translate-y-1/2 items-center justify-center h-20" aria-hidden="true">
                    <div className="w-px h-full bg-border relative flex items-center justify-center">
                      <Mountain className="absolute size-3 text-border bg-background" strokeWidth={1.5} />
                    </div>
                  </div>}

                <div className="mb-4 inline-flex items-center justify-center size-12 rounded-md border border-border text-chart-1 group-hover:border-chart-1 transition-colors">
                  <Icon className="size-6" strokeWidth={1.5} />
                </div>
                <h3 className="font-default font-semibold text-base text-foreground mb-1.5 tracking-tight">
                  {cert.label}
                </h3>
                <p className="font-default text-sm text-muted-foreground leading-relaxed">
                  {cert.description}
                </p>
              </div>;
        })}
        </div>
      </div>

      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-100%); }
        }
        .animate-marquee {
          animation: marquee 40s linear infinite;
        }
      `}</style>
    </section>;
}